import { render } from "./ArrowsDownUp.vue?vue&type=template&id=35ce8395"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ArrowsDownUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35ce8395"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35ce8395', __exports__)) {
    api.reload('35ce8395', __exports__)
  }
  
  module.hot.accept("./ArrowsDownUp.vue?vue&type=template&id=35ce8395", () => {
    api.rerender('35ce8395', render)
  })

}


export default __exports__